module.exports = __webpack_public_path__ + "img/inspiration_05@2x.59c8d7f.webp";